import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConfirmationAlertState } from "./types";

const initialState: ConfirmationAlertState = {
  isOpen: false,
  title: "",
  description: "",
  confirmText: "Confirmar",
  isLoading: false,
  onConfirm: null,
};

const confirmationAlertSlice = createSlice({
  name: "confirmationAlert",
  initialState,
  reducers: {
    openAlert(state, action: PayloadAction<ConfirmationAlertState>) {
      state.isOpen = action.payload.isOpen;
      state.title = action.payload.title;
      state.description = action.payload.description;
      state.confirmText = action.payload.confirmText;
      state.isLoading = action.payload.isLoading;
      state.onConfirm = action.payload.onConfirm;
    },
  },
});

export const { openAlert } = confirmationAlertSlice.actions;
export default confirmationAlertSlice.reducer;
